/**
 * gift-modal.js
 * Luxe Inlay Kaartje Upsell — Dawn Thema
 * 
 * Werking:
 * 1. Onderschept de 'Afrekenen' knop in de Cart Drawer
 * 2. Toont een modal met de vraag of het een cadeau is
 * 3. Voegt bij 'Ja' het kaartje toe via cart/add.js (async/await)
 * 4. Slaat cart attribute op via cart/update.js
 * 5. Redirect naar /checkout pas NA server-bevestiging (race-condition fix)
 */

(function () {
  'use strict';

  // ─── CONFIGURATIE ────────────────────────────────────────────────────────────
  const GIFT_VARIANT_ID = 53229359268177;   // Variant ID van "Luxe Inlay Kaartje"
  const GIFT_PRICE_LABEL = '€1,50';
  const MODAL_ID = 'gift-upsell-modal';
  // ─────────────────────────────────────────────────────────────────────────────

  // ── HTML van de modal injecteren in <body> ───────────────────────────────────
  function injectModal() {
    if (document.getElementById(MODAL_ID)) return; // al aanwezig

    const modal = document.createElement('div');
    modal.id = MODAL_ID;
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'gift-modal-title');
    modal.setAttribute('aria-hidden', 'true');

    modal.innerHTML = `
      <div class="gm-backdrop"></div>
      <div class="gm-card">
        <!-- Stap 1: vraag -->
        <div class="gm-step" id="gm-step-ask">
          <div class="gm-icon">🎁</div>
          <h2 class="gm-title" id="gift-modal-title">Is het een cadeau?</h2>
          <p class="gm-sub">Voeg een handgeschreven, persoonlijk kaartje toe voor slechts <strong>${GIFT_PRICE_LABEL}</strong>.</p>
          <div class="gm-actions">
            <button class="gm-btn gm-btn--yes" id="gm-btn-yes">Ja, voeg kaartje toe</button>
            <button class="gm-btn gm-btn--no"  id="gm-btn-no">Nee, direct afrekenen</button>
          </div>
        </div>

        <!-- Stap 2: bericht schrijven -->
        <div class="gm-step gm-step--hidden" id="gm-step-write">
          <div class="gm-icon">✍️</div>
          <h2 class="gm-title">Schrijf je boodschap</h2>
          <p class="gm-sub">Dit wordt met de hand op het kaartje geschreven. Kies een ander bezorgadres om direct dit als cadeau te versturen.</p>
          <textarea
            id="gm-message"
            class="gm-textarea"
            placeholder="'Speciaal voor jou! Een klein doosje met een grote opdracht; jou vandaag een beetje blij maken.'"
            maxlength="200"
            rows="4"
          ></textarea>
<span class="gm-charcount"><span id="gm-chars">0</span> / 200</span>
          <div class="gm-actions">
            <button class="gm-btn gm-btn--primary" id="gm-btn-add">
              <span class="gm-btn-text">Toevoegen &amp; Afrekenen</span>
              <span class="gm-btn-spinner" aria-hidden="true"></span>
            </button>
            <button class="gm-btn gm-btn--ghost" id="gm-btn-back">← Terug</button>
          </div>
          <p class="gm-error gm-step--hidden" id="gm-error">Er ging iets mis. Probeer het opnieuw.</p>
        </div>

        <button class="gm-close" id="gm-close" aria-label="Sluiten">&times;</button>
      </div>
    `;

    document.body.appendChild(modal);
    injectStyles();
    bindEvents(modal);
  }

  // ── CSS injecteren (één keer) ─────────────────────────────────────────────────
  function injectStyles() {
    if (document.getElementById('gift-modal-styles')) return;
    const style = document.createElement('style');
    style.id = 'gift-modal-styles';
    style.textContent = `
      /* ── Backdrop ── */
      #${MODAL_ID} {
        position: fixed; inset: 0; z-index: 99999;
        display: flex; align-items: center; justify-content: center;
        opacity: 0; visibility: hidden;
        transition: opacity 0.25s ease, visibility 0.25s ease;
      }
      #${MODAL_ID}[aria-hidden="false"] {
        opacity: 1; visibility: visible;
      }
      .gm-backdrop {
        position: absolute; inset: 0;
        background: rgba(0,0,0,0.45);
        backdrop-filter: blur(3px);
      }

      /* ── Card ── */
      .gm-card {
        position: relative; z-index: 1;
        background: #fff;
        border-radius: 16px;
        padding: 2.5rem 2rem 2rem;
    width: 30vw;
min-width: 320px;
padding: 3rem 2.5rem 2.5rem;
        box-shadow: 0 24px 60px rgba(0,0,0,0.18);
        transform: translateY(16px);
        transition: transform 0.3s cubic-bezier(.22,1,.36,1);
      }
      #${MODAL_ID}[aria-hidden="false"] .gm-card { transform: translateY(0); }

      /* ── Steps ── */
      .gm-step { display: flex; flex-direction: column; gap: .75rem; }
      .gm-step--hidden { display: none !important; }

      /* ── Typografie ── */
      .gm-icon { font-size: 2.4rem; line-height: 1; }
      .gm-title {
        margin: 0;
        font-size: 3.0rem;
        font-weight: 400;
        color: #111;
        line-height: 1.2;
      }
      .gm-sub {
        margin: 0;
        font-size: 2.0rem;
        color: #555;
        line-height: 1.5;
      }

      /* ── Knoppen ── */
      .gm-actions { display: flex; flex-direction: column; gap: .6rem; margin-top: .5rem; }
      .gm-btn {
        display: flex; align-items: center; justify-content: center; gap: .5rem;
        width: 100%; padding: .85rem 1rem;
        border: none; border-radius: 10px;
        font-size: 1.4rem; font-weight: 400;
        cursor: pointer; transition: filter .15s ease, transform .1s ease;
      }
      .gm-btn:active { transform: scale(.98); }
      .gm-btn--yes, .gm-btn--primary {
        background: #111; color: #fff;
      }
      .gm-btn--yes:hover, .gm-btn--primary:hover { filter: brightness(1.3); }
      .gm-btn--no  { background: #f3f3f3; color: #333; }
      .gm-btn--no:hover  { filter: brightness(.95); }
      .gm-btn--ghost { background: transparent; color: #666; font-weight: 400; font-size: 1.6rem; }
      .gm-btn--ghost:hover { color: #111; }
      .gm-btn:disabled { opacity: .55; cursor: not-allowed; }

      /* ── Spinner ── */
      .gm-btn-spinner {
        display: none;
        width: 16px; height: 16px;
        border: 2px solid rgba(255,255,255,.4);
        border-top-color: #fff;
        border-radius: 50%;
        animation: gm-spin .7s linear infinite;
      }
      .gm-btn--loading .gm-btn-spinner { display: block; }
      .gm-btn--loading .gm-btn-text    { opacity: .7; }
      @keyframes gm-spin { to { transform: rotate(360deg); } }

      /* ── Textarea ── */
      .gm-textarea {
        width: 100%; box-sizing: border-box;
        padding: .75rem;
        border: 1.5px solid #ddd; border-radius: 8px;
        font-size: 1.1rem; line-height: 1.5;
        resize: vertical;
        transition: border-color .2s;
        font-family: inherit;
        font-style: italic;
        color: #999;
      }
      .gm-textarea:focus { outline: none; border-color: #111; }
      .gm-charcount { font-size: 1.4rem; color: #999; text-align: right; margin-top: -.4rem; }
     .gm-note { margin: 0; font-size: 1.3rem; color: #888; line-height: 1.5; }

      /* ── Error ── */
      .gm-error {
        color: #c0392b;
        font-size: .85rem;
        text-align: center;
        margin: 0;
      }

      /* ── Sluit-knop ── */
      .gm-close {
        position: absolute; top: .9rem; right: 1rem;
        background: none; border: none;
        font-size: 4.2rem; line-height: 1;
        color: #aaa; cursor: pointer;
        padding: .25rem .4rem;
        border-radius: 6px;
        transition: color .15s;
      }
      .gm-close:hover { color: #333; }
    `;
    document.head.appendChild(style);
  }

  // ── Event bindings ────────────────────────────────────────────────────────────
  function bindEvents(modal) {
    const backdrop  = modal.querySelector('.gm-backdrop');
    const btnClose  = modal.querySelector('#gm-close');
    const btnYes    = modal.querySelector('#gm-btn-yes');
    const btnNo     = modal.querySelector('#gm-btn-no');
    const btnAdd    = modal.querySelector('#gm-btn-add');
    const btnBack   = modal.querySelector('#gm-btn-back');
    const textarea  = modal.querySelector('#gm-message');
    const charCount = modal.querySelector('#gm-chars');
    const errorEl   = modal.querySelector('#gm-error');

    // Teken-teller
    textarea.addEventListener('input', () => {
      charCount.textContent = textarea.value.length;
    });

    // Sluiten via backdrop / ×
    [backdrop, btnClose].forEach(el =>
      el.addEventListener('click', closeModal)
    );

    // ESC-toets
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
        closeModal();
      }
    });

    // "Nee" → direct naar checkout
    btnNo.addEventListener('click', () => {
      closeModal();
      window.location.href = '/checkout';
    });

    // "Ja" → toon stap 2
    btnYes.addEventListener('click', () => {
      showStep('gm-step-write');
      textarea.focus();
    });

    // "← Terug"
    btnBack.addEventListener('click', () => {
      errorEl.classList.add('gm-step--hidden');
      showStep('gm-step-ask');
    });

    // "Toevoegen & Afrekenen"
    btnAdd.addEventListener('click', async () => {
      const message = textarea.value.trim();
      setLoading(btnAdd, true);
      errorEl.classList.add('gm-step--hidden');

      try {
        // Stap A: voeg het cadeauproduct toe aan de cart
        await addGiftProduct(GIFT_VARIANT_ID);

        // Stap B: sla de boodschap op als cart attribute (optioneel als leeg)
        if (message) {
          await updateCartAttributes({ 'Inlay boodschap': message });
        }

        // Stap C: pas ná server-bevestiging → redirect (race-condition fix)
        window.location.href = '/checkout';

      } catch (err) {
        console.error('[GiftModal] Fout:', err);
        setLoading(btnAdd, false);
        errorEl.textContent = err.userMessage || 'Er ging iets mis. Probeer het opnieuw.';
        errorEl.classList.remove('gm-step--hidden');
      }
    });
  }

  // ── Shopify API helpers ───────────────────────────────────────────────────────

  /**
   * Voegt een variant toe aan de cart.
   * Gooit een fout als het product al in de cart zit (om dubbele toevoeging te voorkomen).
   */
  async function addGiftProduct(variantId) {
    // Controleer of het product al in de cart zit
    const cartState = await fetchCart();
    const alreadyInCart = cartState.items.some(
      item => item.variant_id === variantId
    );
    if (alreadyInCart) return; // al toegevoegd, geen actie nodig

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    });

    if (!response.ok) {
      const errData = await response.json().catch(() => ({}));
      const error = new Error(errData.description || 'cart/add.js mislukt');
      error.userMessage = errData.description || 'Het kaartje kon niet worden toegevoegd.';
      throw error;
    }

    return response.json();
  }

  /**
   * Werkt cart attributes bij via cart/update.js.
   * Merget met bestaande attributes zodat andere data niet verloren gaat.
   */
  async function updateCartAttributes(newAttributes) {
    const cartState = await fetchCart();
    const merged = Object.assign({}, cartState.attributes, newAttributes);

    const response = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: merged }),
    });

    if (!response.ok) {
      const error = new Error('cart/update.js mislukt');
      error.userMessage = 'De boodschap kon niet worden opgeslagen.';
      throw error;
    }

    return response.json();
  }

  /** Haalt de huidige cart-status op. */
  async function fetchCart() {
    const response = await fetch('/cart.js', {
      headers: { 'Accept': 'application/json' },
    });
    if (!response.ok) throw new Error('cart.js ophalen mislukt');
    return response.json();
  }

  // ── UI helpers ────────────────────────────────────────────────────────────────
  function openModal() {
    const modal = document.getElementById(MODAL_ID);
    if (!modal) return;
    showStep('gm-step-ask');
    // Reset textarea
    modal.querySelector('#gm-message').value = '';
    modal.querySelector('#gm-chars').textContent = '0';
    modal.querySelector('#gm-error').classList.add('gm-step--hidden');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';

    // Focus trap: focus op eerste knop
    setTimeout(() => modal.querySelector('.gm-btn').focus(), 50);
  }

  function closeModal() {
    const modal = document.getElementById(MODAL_ID);
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function showStep(stepId) {
    document.querySelectorAll(`#${MODAL_ID} .gm-step`).forEach(s => {
      s.classList.toggle('gm-step--hidden', s.id !== stepId);
    });
  }

  function setLoading(btn, loading) {
    btn.disabled = loading;
    btn.classList.toggle('gm-btn--loading', loading);
  }

  // ── Checkout-knop onderscheppen in Cart Drawer ────────────────────────────────
  /**
   * Dawn's cart-drawer laadt zijn HTML dynamisch opnieuw na elke cart-update.
   * Daarom gebruiken we event delegation op document i.p.v. directe binding.
   * 
   * De checkout-knop in Dawn heeft doorgaans:
   *   - Een <button> of <a> met name="checkout" of [href="/checkout"]
   *   - Zit in een element met class "cart__ctas" of "cart-drawer__footer"
   */
  function interceptCheckoutButton() {
    document.addEventListener('click', function (e) {
      // Zoek de dichtstbijzijnde checkout-trigger
      const btn = e.target.closest(
  '[name="gift-checkout"], ' +
  '#gift-checkout-trigger'
);
      if (!btn) return;

      // Voorkom standaard navigatie / form submit
      e.preventDefault();
      e.stopImmediatePropagation();

      openModal();
    }, true); // capture phase zodat we vóór Dawn's eigen handlers zitten
  }

  // ── Init ──────────────────────────────────────────────────────────────────────
  function init() {
    injectModal();
    interceptCheckoutButton();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
